import { render } from "./Datalists.vue?vue&type=template&id=8d1d20fa"
import script from "./Datalists.vue?vue&type=script&lang=js"
export * from "./Datalists.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/Datalists.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d1d20fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d1d20fa', __exports__)) {
    api.reload('8d1d20fa', __exports__)
  }
  
  module.hot.accept("./Datalists.vue?vue&type=template&id=8d1d20fa", () => {
    api.rerender('8d1d20fa', render)
  })

}


export default __exports__